import { Port } from './port.model';

export const portMock = new Port({
  airport: '',
  code: 'MIA',
  country: 'DNK',
  name: 'MIAMI',
  timezoneOffsetEST: '0',
  type: 'T',
});
